module.exports = __webpack_public_path__ + "static/media/NISA_FINANCE_Trans - Copy.99a87e7c.png";